import styled from 'styled-components';

export const ContactHeaderWrapper = styled.header<{ $isLoggedIn: boolean }>`
  width: 100%;
  min-height: 12rem;
  background-image: linear-gradient(to bottom, #575e78, #4e546b);
  padding: ${({ $isLoggedIn }) => ($isLoggedIn ? '2.5rem' : '5rem')} 0 2.5rem 0;
`;

export const ContactHeaderTitle = styled.h1`
  font-weight: 300;
  color: ${({ theme }) => theme.white.a10};
`;

export const ContactHeaderSubTitle = styled.h2`
  font-size: 0.8rem;
  line-height: 2.17;
  font-weight: 100;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.white.a10};
`;

export const IconsBox = styled.div`
  margin-top: 22px;
  display: flex;
  a {
    display: block;
    margin-right: 7px;
    color: white;
    fill: transparent;

    :last-child {
      margin-right: 0;
    }

    &:hover {
      .iconFacebook {
        fill: #3b5998;
        color: #3b5998;
      }
      .iconTwitter {
        fill: #55acee;
        color: #55acee;
      }
      .iconYoutube {
        fill: #b00;
        color: #b00;
      }
      .iconInstagram {
        fill: #fb3958;
        color: #fb3958;
      }
      .iconXing {
        fill: #0d6567;
        color: #0d6567;
      }
    }
  }
`;
